const STORAGE_PREFIX = "autoapp:activeProduct";

const INVALID_PARTS = new Set(["", "undefined", "null"]);

const normalizePart = (value) => {
  if (typeof value !== "string") return null;
  const normalized = value.trim();
  return INVALID_PARTS.has(normalized) ? null : normalized;
};

const storageKey = (uid) => {
  const safeUid = normalizePart(uid);
  return safeUid ? `${STORAGE_PREFIX}:${safeUid}` : null;
};

/**
 * WEB-004: persiste el último producto (app) elegido por UID. Sólo el
 * identificador de app, nunca permisos ni contraseña.
 */
export const getActiveProductApp = (uid) => {
  try {
    const key = storageKey(uid);
    if (!key) return null;
    const raw = localStorage.getItem(key);
    const normalized = normalizePart(raw);
    if (raw !== null && !normalized) localStorage.removeItem(key);
    return normalized;
  } catch {
    return null;
  }
};

export const setActiveProductApp = (uid, app) => {
  try {
    const key = storageKey(uid);
    if (!key) return false;
    const safeApp = normalizePart(app);
    if (!safeApp) {
      localStorage.removeItem(key);
      return false;
    }
    localStorage.setItem(key, safeApp);
    return true;
  } catch (error) {
    console.error("Error persistiendo producto activo:", error);
    return false;
  }
};

export const clearActiveProduct = (uid) => {
  try {
    const key = storageKey(uid);
    if (!key) return;
    localStorage.removeItem(key);
  } catch {
    /* Storage puede estar deshabilitado por el navegador. */
  }
};
